// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Xw7N","selects":"Documents_selects__QzQjG"};